// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * Draft v0.11.7
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
.DraftEditor-editorContainer,
.DraftEditor-root,
.public-DraftEditor-content {
	height: inherit;
	text-align: initial;
}
.public-DraftEditor-content[contenteditable="true"] {
	-webkit-user-modify: read-write-plaintext-only;
}
.DraftEditor-root {
	position: relative;
}
.DraftEditor-editorContainer {
	background-color: rgba(255, 255, 255, 0);
	border-left: 0.1px solid transparent;
	position: relative;
	z-index: 1;
}
.public-DraftEditor-block {
	position: relative;
}
.DraftEditor-alignLeft .public-DraftStyleDefault-block {
	text-align: left;
}
.DraftEditor-alignLeft .public-DraftEditorPlaceholder-root {
	left: 0;
	text-align: left;
}
.DraftEditor-alignCenter .public-DraftStyleDefault-block {
	text-align: center;
}
.DraftEditor-alignCenter .public-DraftEditorPlaceholder-root {
	margin: 0 auto;
	text-align: center;
	width: 100%;
}
.DraftEditor-alignRight .public-DraftStyleDefault-block {
	text-align: right;
}
.DraftEditor-alignRight .public-DraftEditorPlaceholder-root {
	right: 0;
	text-align: right;
}
.public-DraftEditorPlaceholder-root {
	color: #9197a3;
	position: absolute;
	width: 100%;
	z-index: 1;
}
.public-DraftEditorPlaceholder-hasFocus {
	color: transparent;
}
.DraftEditorPlaceholder-hidden {
	display: none;
}
.public-DraftStyleDefault-block {
	position: relative;
	white-space: pre-wrap;
}
.public-DraftStyleDefault-ltr {
	direction: ltr;
	text-align: left;
}
.public-DraftStyleDefault-rtl {
	direction: rtl;
	text-align: right;
}
.public-DraftStyleDefault-listLTR {
	direction: ltr;
}
.public-DraftStyleDefault-listRTL {
	direction: rtl;
}
.public-DraftStyleDefault-ol,
.public-DraftStyleDefault-ul {
	margin: 16px 0;
	padding: 0;
}
.public-DraftStyleDefault-depth0.public-DraftStyleDefault-listLTR {
	margin-left: 1.5em;
}
.public-DraftStyleDefault-depth0.public-DraftStyleDefault-listRTL {
	margin-right: 1.5em;
}
.public-DraftStyleDefault-depth1.public-DraftStyleDefault-listLTR {
	margin-left: 3em;
}
.public-DraftStyleDefault-depth1.public-DraftStyleDefault-listRTL {
	margin-right: 3em;
}
.public-DraftStyleDefault-depth2.public-DraftStyleDefault-listLTR {
	margin-left: 4.5em;
}
.public-DraftStyleDefault-depth2.public-DraftStyleDefault-listRTL {
	margin-right: 4.5em;
}
.public-DraftStyleDefault-depth3.public-DraftStyleDefault-listLTR {
	margin-left: 6em;
}
.public-DraftStyleDefault-depth3.public-DraftStyleDefault-listRTL {
	margin-right: 6em;
}
.public-DraftStyleDefault-depth4.public-DraftStyleDefault-listLTR {
	margin-left: 7.5em;
}
.public-DraftStyleDefault-depth4.public-DraftStyleDefault-listRTL {
	margin-right: 7.5em;
}
.public-DraftStyleDefault-unorderedListItem {
	list-style-type: square;
	position: relative;
}
.public-DraftStyleDefault-unorderedListItem.public-DraftStyleDefault-depth0 {
	list-style-type: disc;
}
.public-DraftStyleDefault-unorderedListItem.public-DraftStyleDefault-depth1 {
	list-style-type: circle;
}
.public-DraftStyleDefault-orderedListItem {
	list-style-type: none;
	position: relative;
}
.public-DraftStyleDefault-orderedListItem.public-DraftStyleDefault-listLTR:before {
	left: -36px;
	position: absolute;
	text-align: right;
	width: 30px;
}
.public-DraftStyleDefault-orderedListItem.public-DraftStyleDefault-listRTL:before {
	position: absolute;
	right: -36px;
	text-align: left;
	width: 30px;
}
.public-DraftStyleDefault-orderedListItem:before {
	content: counter(ol0) ". ";
	counter-increment: ol0;
}
.public-DraftStyleDefault-orderedListItem.public-DraftStyleDefault-depth1:before {
	content: counter(ol1, lower-alpha) ". ";
	counter-increment: ol1;
}
.public-DraftStyleDefault-orderedListItem.public-DraftStyleDefault-depth2:before {
	content: counter(ol2, lower-roman) ". ";
	counter-increment: ol2;
}
.public-DraftStyleDefault-orderedListItem.public-DraftStyleDefault-depth3:before {
	content: counter(ol3) ". ";
	counter-increment: ol3;
}
.public-DraftStyleDefault-orderedListItem.public-DraftStyleDefault-depth4:before {
	content: counter(ol4, lower-alpha) ". ";
	counter-increment: ol4;
}
.public-DraftStyleDefault-depth0.public-DraftStyleDefault-reset {
	counter-reset: ol0;
}
.public-DraftStyleDefault-depth1.public-DraftStyleDefault-reset {
	counter-reset: ol1;
}
.public-DraftStyleDefault-depth2.public-DraftStyleDefault-reset {
	counter-reset: ol2;
}
.public-DraftStyleDefault-depth3.public-DraftStyleDefault-reset {
	counter-reset: ol3;
}
.public-DraftStyleDefault-depth4.public-DraftStyleDefault-reset {
	counter-reset: ol4;
}
`, "",{"version":3,"sources":["webpack://./src/containers/cases/messages/draftJSEditor.css"],"names":[],"mappings":"AAAA;;;;;;;EAOE;AACF;;;CAGC,eAAe;CACf,mBAAmB;AACpB;AACA;CACC,8CAA8C;AAC/C;AACA;CACC,kBAAkB;AACnB;AACA;CACC,wCAAwC;CACxC,oCAAoC;CACpC,kBAAkB;CAClB,UAAU;AACX;AACA;CACC,kBAAkB;AACnB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,OAAO;CACP,gBAAgB;AACjB;AACA;CACC,kBAAkB;AACnB;AACA;CACC,cAAc;CACd,kBAAkB;CAClB,WAAW;AACZ;AACA;CACC,iBAAiB;AAClB;AACA;CACC,QAAQ;CACR,iBAAiB;AAClB;AACA;CACC,cAAc;CACd,kBAAkB;CAClB,WAAW;CACX,UAAU;AACX;AACA;CACC,kBAAkB;AACnB;AACA;CACC,aAAa;AACd;AACA;CACC,kBAAkB;CAClB,qBAAqB;AACtB;AACA;CACC,cAAc;CACd,gBAAgB;AACjB;AACA;CACC,cAAc;CACd,iBAAiB;AAClB;AACA;CACC,cAAc;AACf;AACA;CACC,cAAc;AACf;AACA;;CAEC,cAAc;CACd,UAAU;AACX;AACA;CACC,kBAAkB;AACnB;AACA;CACC,mBAAmB;AACpB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,iBAAiB;AAClB;AACA;CACC,kBAAkB;AACnB;AACA;CACC,mBAAmB;AACpB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,iBAAiB;AAClB;AACA;CACC,kBAAkB;AACnB;AACA;CACC,mBAAmB;AACpB;AACA;CACC,uBAAuB;CACvB,kBAAkB;AACnB;AACA;CACC,qBAAqB;AACtB;AACA;CACC,uBAAuB;AACxB;AACA;CACC,qBAAqB;CACrB,kBAAkB;AACnB;AACA;CACC,WAAW;CACX,kBAAkB;CAClB,iBAAiB;CACjB,WAAW;AACZ;AACA;CACC,kBAAkB;CAClB,YAAY;CACZ,gBAAgB;CAChB,WAAW;AACZ;AACA;CACC,0BAA0B;CAC1B,sBAAsB;AACvB;AACA;CACC,uCAAuC;CACvC,sBAAsB;AACvB;AACA;CACC,uCAAuC;CACvC,sBAAsB;AACvB;AACA;CACC,0BAA0B;CAC1B,sBAAsB;AACvB;AACA;CACC,uCAAuC;CACvC,sBAAsB;AACvB;AACA;CACC,kBAAkB;AACnB;AACA;CACC,kBAAkB;AACnB;AACA;CACC,kBAAkB;AACnB;AACA;CACC,kBAAkB;AACnB;AACA;CACC,kBAAkB;AACnB","sourcesContent":["/**\n * Draft v0.11.7\n *\n * Copyright (c) Facebook, Inc. and its affiliates.\n *\n * This source code is licensed under the MIT license found in the\n * LICENSE file in the root directory of this source tree.\n */\n.DraftEditor-editorContainer,\n.DraftEditor-root,\n.public-DraftEditor-content {\n\theight: inherit;\n\ttext-align: initial;\n}\n.public-DraftEditor-content[contenteditable=\"true\"] {\n\t-webkit-user-modify: read-write-plaintext-only;\n}\n.DraftEditor-root {\n\tposition: relative;\n}\n.DraftEditor-editorContainer {\n\tbackground-color: rgba(255, 255, 255, 0);\n\tborder-left: 0.1px solid transparent;\n\tposition: relative;\n\tz-index: 1;\n}\n.public-DraftEditor-block {\n\tposition: relative;\n}\n.DraftEditor-alignLeft .public-DraftStyleDefault-block {\n\ttext-align: left;\n}\n.DraftEditor-alignLeft .public-DraftEditorPlaceholder-root {\n\tleft: 0;\n\ttext-align: left;\n}\n.DraftEditor-alignCenter .public-DraftStyleDefault-block {\n\ttext-align: center;\n}\n.DraftEditor-alignCenter .public-DraftEditorPlaceholder-root {\n\tmargin: 0 auto;\n\ttext-align: center;\n\twidth: 100%;\n}\n.DraftEditor-alignRight .public-DraftStyleDefault-block {\n\ttext-align: right;\n}\n.DraftEditor-alignRight .public-DraftEditorPlaceholder-root {\n\tright: 0;\n\ttext-align: right;\n}\n.public-DraftEditorPlaceholder-root {\n\tcolor: #9197a3;\n\tposition: absolute;\n\twidth: 100%;\n\tz-index: 1;\n}\n.public-DraftEditorPlaceholder-hasFocus {\n\tcolor: transparent;\n}\n.DraftEditorPlaceholder-hidden {\n\tdisplay: none;\n}\n.public-DraftStyleDefault-block {\n\tposition: relative;\n\twhite-space: pre-wrap;\n}\n.public-DraftStyleDefault-ltr {\n\tdirection: ltr;\n\ttext-align: left;\n}\n.public-DraftStyleDefault-rtl {\n\tdirection: rtl;\n\ttext-align: right;\n}\n.public-DraftStyleDefault-listLTR {\n\tdirection: ltr;\n}\n.public-DraftStyleDefault-listRTL {\n\tdirection: rtl;\n}\n.public-DraftStyleDefault-ol,\n.public-DraftStyleDefault-ul {\n\tmargin: 16px 0;\n\tpadding: 0;\n}\n.public-DraftStyleDefault-depth0.public-DraftStyleDefault-listLTR {\n\tmargin-left: 1.5em;\n}\n.public-DraftStyleDefault-depth0.public-DraftStyleDefault-listRTL {\n\tmargin-right: 1.5em;\n}\n.public-DraftStyleDefault-depth1.public-DraftStyleDefault-listLTR {\n\tmargin-left: 3em;\n}\n.public-DraftStyleDefault-depth1.public-DraftStyleDefault-listRTL {\n\tmargin-right: 3em;\n}\n.public-DraftStyleDefault-depth2.public-DraftStyleDefault-listLTR {\n\tmargin-left: 4.5em;\n}\n.public-DraftStyleDefault-depth2.public-DraftStyleDefault-listRTL {\n\tmargin-right: 4.5em;\n}\n.public-DraftStyleDefault-depth3.public-DraftStyleDefault-listLTR {\n\tmargin-left: 6em;\n}\n.public-DraftStyleDefault-depth3.public-DraftStyleDefault-listRTL {\n\tmargin-right: 6em;\n}\n.public-DraftStyleDefault-depth4.public-DraftStyleDefault-listLTR {\n\tmargin-left: 7.5em;\n}\n.public-DraftStyleDefault-depth4.public-DraftStyleDefault-listRTL {\n\tmargin-right: 7.5em;\n}\n.public-DraftStyleDefault-unorderedListItem {\n\tlist-style-type: square;\n\tposition: relative;\n}\n.public-DraftStyleDefault-unorderedListItem.public-DraftStyleDefault-depth0 {\n\tlist-style-type: disc;\n}\n.public-DraftStyleDefault-unorderedListItem.public-DraftStyleDefault-depth1 {\n\tlist-style-type: circle;\n}\n.public-DraftStyleDefault-orderedListItem {\n\tlist-style-type: none;\n\tposition: relative;\n}\n.public-DraftStyleDefault-orderedListItem.public-DraftStyleDefault-listLTR:before {\n\tleft: -36px;\n\tposition: absolute;\n\ttext-align: right;\n\twidth: 30px;\n}\n.public-DraftStyleDefault-orderedListItem.public-DraftStyleDefault-listRTL:before {\n\tposition: absolute;\n\tright: -36px;\n\ttext-align: left;\n\twidth: 30px;\n}\n.public-DraftStyleDefault-orderedListItem:before {\n\tcontent: counter(ol0) \". \";\n\tcounter-increment: ol0;\n}\n.public-DraftStyleDefault-orderedListItem.public-DraftStyleDefault-depth1:before {\n\tcontent: counter(ol1, lower-alpha) \". \";\n\tcounter-increment: ol1;\n}\n.public-DraftStyleDefault-orderedListItem.public-DraftStyleDefault-depth2:before {\n\tcontent: counter(ol2, lower-roman) \". \";\n\tcounter-increment: ol2;\n}\n.public-DraftStyleDefault-orderedListItem.public-DraftStyleDefault-depth3:before {\n\tcontent: counter(ol3) \". \";\n\tcounter-increment: ol3;\n}\n.public-DraftStyleDefault-orderedListItem.public-DraftStyleDefault-depth4:before {\n\tcontent: counter(ol4, lower-alpha) \". \";\n\tcounter-increment: ol4;\n}\n.public-DraftStyleDefault-depth0.public-DraftStyleDefault-reset {\n\tcounter-reset: ol0;\n}\n.public-DraftStyleDefault-depth1.public-DraftStyleDefault-reset {\n\tcounter-reset: ol1;\n}\n.public-DraftStyleDefault-depth2.public-DraftStyleDefault-reset {\n\tcounter-reset: ol2;\n}\n.public-DraftStyleDefault-depth3.public-DraftStyleDefault-reset {\n\tcounter-reset: ol3;\n}\n.public-DraftStyleDefault-depth4.public-DraftStyleDefault-reset {\n\tcounter-reset: ol4;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
